export default __webpack_public_path__ + "static/media/robos.86e37abb.svg";